import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationStorageService } from '@core/storage/jwt-storage-service';
import { StorageService } from '@core/storage/storage.service';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { HttpMonitoringService } from './http-monitoring.service';
import { ToastService } from './toast.service';

@Injectable()
export class JWTInterceptor implements HttpInterceptor {

    constructor(
        private _storageService: StorageService,
        private _toastService: ToastService,
        private _httpMonitoringService: HttpMonitoringService,
        protected _router: Router,
        private _authenticationStorageService: AuthenticationStorageService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let skipToken = false;
        let skipOther = false;
        if (req.url.endsWith('/Token')) {
            skipToken = true;
        } else if (req.url.includes('geniusatsfeeback') || req.url.includes('search.php') || req.url.endsWith('/resetpassword') || req.url.includes('/authorise/') || req.url.toLowerCase().indexOf('forgotpassword') !== -1 || req.url.toLowerCase().includes('authoriseoffer')) {
            skipOther = true;
        }

        let dupReq = req.clone();
        let reqType = req.method;

        const token = this._authenticationStorageService.getJWT();
        if (!token && skipToken === false && skipOther === false) {
            this._storageService.clearTimeoutStorage();
            if (!this._router.url.includes('/account/login')) {
                const url = encodeURIComponent(this._router.url);
                this._router.navigate(['/account/login'], { queryParams: { returnUrl: url }, queryParamsHandling: 'merge' });
            }
            return EMPTY;
        } else if (skipToken === false && skipOther === false) {

            const JWT = `bearer ${token.access_token}`;
            const veneer = <string>this._storageService.getItem('veneer');
            if (!!veneer) {
                dupReq = req.clone({
                    headers: new HttpHeaders(
                        {
                            'Content-Type': 'application/json',
                            Authorization: JWT,
                            Fingerprint: '1c8167aafb5b9d9b072bac585441cb5f',
                            clientId: token.clientId,
                            veneer: veneer
                        })
                });
            }
            else {
                dupReq = req.clone({
                    headers: new HttpHeaders(
                        {
                            'Content-Type': 'application/json',
                            Authorization: JWT,
                            Fingerprint: '1c8167aafb5b9d9b072bac585441cb5f',
                            clientId: token.clientId
                        })
                });
            }

            // Caching Response
            reqType = req.method;
            if (reqType === 'GET') {
                const reqBody = this._storageService.getFromTimeoutStorage(req.url);
                if (!!reqBody) {
                    return of(reqBody);
                }
            }
        }

        this._httpMonitoringService.addConnection(req.url);
        const removalUrl = req.url;

        return next.handle(dupReq).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    this._httpMonitoringService.removeConnection(event.url);
                    if (reqType === 'GET') {
                        this._storageService.setWithTimeout(event.url, event);
                    }
                }
            }),
            catchError(response => {
                this._httpMonitoringService.removeConnection(response.url);
                if (response instanceof HttpErrorResponse) {
                    if (response.status === 400) {

                        // different response
                        if (skipToken === true) {
                            const tokenError = <any>response.error;
                            this._toastService.error(tokenError.error_description, 3000);
                            return throwError(tokenError);
                        }

                        const error = <any>response.error;
                        const errors = this._getErrorResponseArray(response);
                        this._toastService.error(errors.join(', '), 3000);
                        return of(error);
                    } else if (response.status === 401) {
                        const url = this._router.url;
                        this._toastService.error('Unauthorized', 3000);
                        this._router.navigate(['/account/login'], { queryParams: { returnUrl: url }, queryParamsHandling: 'merge' });
                    } else if (response.status === 403) {
                        this._toastService.error('Unauthorized request', 10000);
                        let error = <any>response.error;
                        return of(error);
                    }
                    if (response.status === 500) {
                        const er = this._getErrorResponseArray(response);
                        this._toastService.error(er.join('</br>'), 3000);
                        return throwError('Server Error');
                    }
                    if (response.status === 0) {
                        this._toastService.error('Security / Server Error', 5000);
                        let error = <any>response.error;
                        return of(error);
                    }
                    if (response.status === 404) {
                        this._toastService.error('Resource not found', 5000);
                        let error = <any>response.error;
                        return of(error);
                    }
                }
                return throwError(response);
            }),
            finalize(() => {
                setTimeout(() => {
                    this._httpMonitoringService.removeConnection(removalUrl);
                }, 1000);
            }),
        );
    }

    private _getErrorResponseArray(err: HttpErrorResponse) {
        const error = <any>err.error;
        if (!!error.ModelState) {
            const keys = Object.keys(error.ModelState);
            const errors = keys.map(key => {
                return <string>error.ModelState[key];
            });
            return errors;
        }
        // message??
        if (!!error.Message) {
            return [error.Message];
        }

        return ['An error has occurred'];
    }
}
